import { Modal } from '@ctsu/react-ctsu-ui';
import { format } from 'date-fns';
import React, { useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { titleAndAria } from "protocol-setup/constants/errorMessages";
import { PSRFormCore } from './PSRForm';

export const getRowData = (value, data) => {
  const dataId = data?.trackbyId || data?.psRpdId;
  return value?.find(v => {
    const rowId = v?.trackbyId || v?.psRpdId;
    return rowId === dataId;
  }) || {};
};


function PSRForm({
  rowData,
  action,
  handleRowUpdate,
  FormValues,
  editMode,
  setEditMode,
  handleCancel,
  today
}) {
  const {
    control,
    handleSubmit,
    trigger,
    formState: { isValid, isDirty }
  } = useForm({
    defaultValues: rowData,
    mode: 'onBlur'
  });

  const onSubmit = (data) => {
    handleRowUpdate(data);
    handleCancel();
  };

  const psrId = rowData?.id || rowData?.psrId || null;

  return (
    <PSRFormCore
      key={psrId}
      selectedPSR={FormValues}
      selectedPSRChangeType={FormValues?.createdBy ? "copy" : "newPSR"}
      editMode={editMode}
      control={control}
      handleSubmit={handleSubmit}
      onSubmit={onSubmit}
      handleCancel={handleCancel}
      isValid={isValid}
      isDirty={isDirty}
      today={today}
      hideFormActions={action === 'view'}
      setEditMode={setEditMode}
      trigger={trigger}
    />
  );
}

export default function ViewPSR({ rowData, action = 'view', handleRowUpdate, children, value }) {
  const [openModal, setModal] = useState(false);
  const [editMode, setEditMode] = useState(action !== 'view');
  const [FormValues, setFormValues] = useState(null);

  const returnBtnRef = useRef(null);

  const today = format(new Date(), 'dd-MMM-yyyy');

  const handleCancel = () => {
    setFormValues(null);
    setTimeout(() => {
      returnBtnRef.current.focus();
      setModal(false);
    }, 100);
  };

  const handleOpenModal = () => {
    setModal(!openModal);
    setFormValues(getRowData(value, rowData));
  };

  const handleSetEditMode = (mode) => {
    setEditMode(mode);
  };

  return (
    <>
      <button
        type="button"
        onClick={() => handleOpenModal()}
        className="btn fn-btn"
        title={action === 'view' ? titleAndAria.viewPsr : titleAndAria.editPsr}
        ref={returnBtnRef}
      >
        {children}
      </button>
      {openModal && (
        <Modal
          id="Protocol_Setup_Request"
          buttonText="Close"
          showCloseBtn={action === 'view'}
          onClose={handleCancel}
          modalTitle={action === 'view' ? titleAndAria.viewPsr : titleAndAria.editPsr}
        >
          <PSRForm
            rowData={rowData}
            action={action}
            handleRowUpdate={handleRowUpdate}
            FormValues={FormValues}
            editMode={editMode}
            setEditMode={handleSetEditMode}
            handleCancel={handleCancel}
            today={today}
          />
        </Modal>
      )}
    </>
  );
}
